import React from 'react';
import { normalizeString } from '../normalizeText';

export const processSchema = (node) => {
    if (!node || node.length <= 0) {
        return <></>;
    }
    if (typeof window !== `undefined`) {
        node.map((schema) => {
            if (schema.field_custom_json_schema) {
                const schemaScriptText = document.createElement(`script`);
                schemaScriptText.type = `application/ld+json`;
                schemaScriptText.text = normalizeString(
                    schema.field_custom_json_schema,
                    [`\\\\`, `\\n`, `\\r`],
                    {
                        removeWhiteSpace: true,
                    }
                );
                document.body.appendChild(schemaScriptText);
            }
        });
    }
};
